import axios from 'axios';
const instance = axios.create({
  baseURL: '/api', // 这里使用了环境变量来设置基本 URL
  //timeout: 5000, // 设置请求超时时间
})

// 查询个人所属企业
export function fetchOrganizations(uid) {
  const token = localStorage.getItem('token');
  return instance.get("/api/org/organizations/list", {
    headers: { token },
    params: {
      userId: uid,
      orgName: ""
    }
  })
}
// 合同管理
export function fetchContractList(data) {
  const token = localStorage.getItem('token');
  return instance.get("/api/sys/sign/info/mysign/page/list", {
    headers: { token },
    params: data 
  })
}
// 审批管理
export function fetchApprovalList(data) {
  const token = localStorage.getItem('token');
  return instance.get("/api/sys/approval/my/page/initiator", {
    headers: { token },
    params: data 
  })
}

// 个人印章
export function fetchManagePsnSeal(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/seal/psn/manage-url", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 机构印章
export function fetchManageOrgSeal(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/seal/org/manage-url", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}

// 查看合同详情
export function fetchDetailUrl(data, params) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/sign-flow/get-sign-url/" + data, params, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 合同签署
export function fetchSignUrl(data, params) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/sign-flow/get-sign-url/" + data, params, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 查询企业成员列表
export function fetchBusinessMember(data) {
  const token = localStorage.getItem('token');
  return instance.get("/api/v3/e-sign/org/list/member", {
    headers: { token },
    params: data 
  })
}
// 切换工作空间
export function fetchSwitchWorkspace(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/org/change/plate/space", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 更新角色
export function updateUser(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/org/update/role", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 添加成员
export function addUser(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/org/add/member", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 删除成员
export function deleteUser(orgId, memberPsnIds) {
  const token = localStorage.getItem('token');
  return instance.delete("/api/v3/e-sign/org/remove/member?orgId=" + orgId + '&memberPsnIds=' + memberPsnIds,
    {
      headers: {
        'Content-Type': 'application/json',
        'token': token
      }
    }
  )
}
// 发起签署
export function fetchSignFlowInitiate(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/sign-flow/sign-flow-initiate", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}
// 查询用户剩余数量
export function fetchUserRemainingNum(data) {
  const token = localStorage.getItem('token');
  return instance.get("/api/benefit/user/benefits", {
    headers: { token },
    params: data 
  })
}
// 查询服务包
export function fetchServiceList(data) {
  const token = localStorage.getItem('token');
  return instance.get("/api/package/server/list", {
    headers: { token },
    params: data 
  })
}
// 验证码登录
export function loginWithVerifyCode(data) {
  return instance.post('/api/login-with-verify-code', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 发送验证码
export function getVerifyCode(data) {
  return instance.post('/api/get-verify-code', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 密码登录
export function loginWithPassword(data) {
  return instance.post('/api/login-with-password', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 校验验证码
export function checkVerifyCode(data) {
  return instance.post('/api/check-verify-code', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 更新新密码
export function updatePassord(data) {
  return instance.post('/api/update-password', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 用户注册
export function register(data) {
  return instance.post('/api/register', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
export function registerPassword(data) {
  return instance.post('/api/register-password', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
// 加入/创建企业
export function fetchOrgAuthUrl(data) {
  const token = localStorage.getItem('token');
  
  return instance.post("/api/v3/e-sign/auth/org/url", data, {
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  })
}

export function postSignFlowInitiate(data) {
  return instance.post('/sign-flow-initiate', data);
}
export function fetchSignFlowList() {
  return instance.get("/sign-flow-list");
}


export function fetchUsers(staff, department, role, orgId) {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  return instance.get("/users", {
    params: {
      s: staff,
      d: department,
      r: role,
      o: orgId,
    },
    headers,
  })
}



export function fetchInvitations(staff, mode, status, orgId) {
  return instance.get("/invitations", {
    params: {
      s: staff,
      m: mode,
      u: status,
      o: orgId,
    }
  })
}

export function deleteInvitation(Ids, orgId) {
  return instance.delete("/invitation", {
    params: {
      org_id: orgId,
      ids: Ids,
    }
  })
}
export function passInvitation(data) {
  return instance.post("/invitation-pass",data, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
export function rejectInvitation(data) {
  return instance.post("/invitation-reject",data, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
export function urgeInvitation(data) {
  return instance.post("/invitation-urge",data, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
export function fetchDepartments(userId, orgId) {
  return instance.get("/departments", {
    params: {
      user_id: userId,
      org_id: orgId,
    }
  })
}
export function fetchDepartmentNodes(orgId) {
  return instance.get("/department-nodes", {
    params: {
      org_id: orgId,
    }
  })
}
export function deleteDepartment(orgId, userId) {
  return instance.delete("/department", {
    params: {
      org_id: orgId,
      id: userId,
    }
  })
}
export function addDepartment(data) {
  return instance.post('/department', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
export function updateDepartment(data) {
  return instance.put('/department', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
export function fetchRoles(orgId) {
  return instance.get("/roles", {
    params: {
      org_id: orgId,
    }
  })
}
export function fetchRoleNodes(orgId) {
  return instance.get("/role-nodes", {
    params: {
      org_id: orgId,
    }
  })
}
export function deleteRole(orgId, Id) {
  return instance.delete("/role", {
    params: {
      org_id: orgId,
      id: Id,
    }
  })
}
export function addRole(data) {
  return instance.post('/role', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
export function updateRole(data) {
  return instance.put('/role', data, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}

export function fetchSignFlowId(bizNo) {
  return instance.get("/sign-flow-id", {
    params: {
      biz_no: bizNo,
    }
  })
}





export function fetchPsnAuthSeal() {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  return instance.get("/get-psn-auth-url", {
    headers,
  })
}

export function fetchOrgAuthSeal() {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  return instance.get("/get-org-auth-url", {
    headers,
  })
}













export function fetchBlockChain() {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  return instance.get("/blockchains", {
    headers,
  })
}

export function fetchPsnAuthUrl() {
  const token = localStorage.getItem('token');
  const headers = {};
  if (token) {
    headers['Authorization'] = token;
  }
  return instance.get("/get-psn-auth-url", {
    headers,
  })
}


